import React, { useLayoutEffect, useRef, useState } from 'react';

export default function DetailRegion({ children, pending, className, fallback = 0, preview }: {
    children: React.ReactNode; pending: boolean; className: string; fallback?: number; preview?: React.ReactNode;
}) {
    const body = useRef<HTMLDivElement>(null);
    const region = useRef<HTMLDivElement>(null);
    const previous = useRef<{ seen: boolean; children: React.ReactNode }>({ seen: false, children: null });
    const [height, setHeight] = useState<number | null>(null);
    useLayoutEffect(() => {
        if (!pending) previous.current = { seen: true, children };
    }, [children, pending]);
    useLayoutEffect(() => {
        const wrapper = region.current;
        if (!wrapper || !body.current) return;
        if (pending) {
            const visibleHeight = wrapper.getBoundingClientRect().height;
            wrapper.style.transition = 'none';
            setHeight(visibleHeight);
            return;
        }
        wrapper.style.transition = '';
        const element = body.current;
        const update = () => setHeight(element.getBoundingClientRect().height);
        const observer = new ResizeObserver(update);
        observer.observe(element);
        update();
        return () => observer.disconnect();
    }, [pending]);
    const retained = pending && previous.current.seen;
    return <div ref={region} className={`${className} lab-detail-region`} data-pending={pending} style={{ height: height ?? (pending ? fallback : undefined) }}>
        <div ref={body} className="lab-detail-region-body" data-retained={retained} inert={retained || undefined} aria-hidden={retained || undefined}>{retained ? previous.current.children : children}</div>
        {retained && preview && <div className="lab-detail-region-preview">{preview}</div>}
    </div>;
}
